export enum FormType {
   Color = 'color',
   Date = 'date',
   DateRange = 'date_range',
   Dropdown = 'dropdown',
   DropdownSearch = 'dropdown_search',
   Number = 'number',
   NumberRange = 'number_range',
   Text = 'text',
   TextArea = 'textarea',
   RadioButtons = 'radio_buttons',
}
